import React, { Fragment, useState, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  Box,
  Button,
  CircularProgress,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  InputAdornment,
  IconButton,
  TextField,
  Typography,
  useMediaQuery
} from "@material-ui/core"
import { useFormik } from "formik"
import { openSnackBar } from "actions/snack-bar"
import { addEmailTag, deleteEmailTag } from "actions/organization"
import AddIcon from "@material-ui/icons/Add"
import useStyles from "./styles"

const ManageTags = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { id, tags = [] } = useSelector(state => state.organization.currentOrg)
  const inputRef = useRef()
  const [loading, setLoading] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState([])

  const formik = useFormik({
    initialValues: {
      tag: ""
    },
    onSubmit: values => {
      setLoading(true)
      dispatch(addEmailTag(id, values.tag))
        .then(response => {
          dispatch(openSnackBar({ message: "Email tag added." }))
        })
        .catch(() => {
          dispatch(openSnackBar({ message: "Error adding email tag." }))
        })
        .finally(() => {
          setLoading(false)
          formik.resetForm()
          inputRef.current.focus()
        })
    }
  })

  const handleDelete = tagId => () => {
    setDeleteLoading(ids => [...ids, tagId])
    dispatch(deleteEmailTag(id, tagId))
      .then(() => {
        dispatch(openSnackBar({ message: "Email tag removed." }))
      })
      .catch(() => {
        dispatch(openSnackBar({ message: "Error removing email tag." }))
      })
      .finally(() => {
        setDeleteLoading(ids => {
          return ids.filter(id => id !== tagId)
        })
      })
  }

  return (
    <Fragment>
      <form onSubmit={formik.handleSubmit}>
        <TextField
          inputRef={inputRef}
          id="tag"
          name="tag"
          label="Create new tag"
          onChange={formik.handleChange}
          value={formik.values.tag}
          disabled={loading}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {!loading ? (
                  <IconButton
                    // color="primary"
                    onClick={formik.handleSubmit}
                    disabled={formik.values.tag.length === 0}
                  >
                    <AddIcon
                      style={
                        formik.values.tag.length === 0
                          ? { color: "lightgray" }
                          : { color: "black" }
                      }
                    />
                  </IconButton>
                ) : (
                  <Box display="flex" justifyContent="center" padding={1.8}>
                    <CircularProgress
                      size={20}
                      classes={{ colorPrimary: classes.spinnerColor }}
                    />
                  </Box>
                )}
              </InputAdornment>
            )
          }}
        />
      </form>
      <Box className={classes.tagContainer}>
        <DialogContent className={classes.tagContent}>
          {tags.length !== 0 &&
            tags.map(tag => (
              <Chip
                key={tag.id}
                className={classes.tag}
                id={tag.id}
                label={tag.name}
                onDelete={handleDelete(tag.id)}
                deleteIcon={
                  deleteLoading.indexOf(tag.id) !== -1 ? (
                    <CircularProgress
                      size={16}
                      classes={{
                        root: classes.deleteLoading,
                        colorPrimary: classes.spinnerColor
                      }}
                    />
                  ) : null
                }
              />
            ))}
        </DialogContent>
      </Box>
    </Fragment>
  )
}

export default ManageTags



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/Communication/CommunicationEmail/ManageTagsDialog/ManageTags/index.jsx